import React from "react";

export const ClientContext = React.createContext<any>(null);

export function useClient<T>() {
  return React.useContext<T>(ClientContext);
}
